import axios from "axios";

export const getCategoriesSettings = (
  organizationId,
  categories,
  lng = "fr"
) => {
  const requestUrl = `/team/task-categories`;
  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      categories: categories ? categories : null,
      lng: lng.charAt(0).toUpperCase() + lng.slice(1)
    }
  });
};

export const getSuperCategoriesSuggestions = (organizationId, lng = "fr") => {
  const requestUrl = `/team/task-super-categories`;

  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      lng: lng.charAt(0).toUpperCase() + lng.slice(1)
    }
  });
};

export const updateCategorySettings = ({
  organization,
  id,
  labels,
  isForced
}) => {
  const requestUrl = `/team/task-Category/edit-name`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("id", id);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);
  formData.append("superCategory", labels.superCategory);
  formData.append("analysisPlan", labels.analysisPlan);
  formData.append("valuations", labels.valuations);
  formData.append("isBillable", labels.updatedBillable);
  formData.append("isForced", isForced ? 1 : 0);

  return axios.post(requestUrl, formData);
};

export const deleteCategorySettings = ({ organization, isForced, id }) => {
  const requestUrl = `/team/task-Category/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("isForced", isForced);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const saveCategorySettings = ({ organization, labels, isBillable }) => {
  const requestUrl = `/team/task-category/add`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);
  formData.append("superCategory", labels.superCategory);
  formData.append("analysisPlan", labels.analysisPlan);
  formData.append("valuation", labels.valuations);
  formData.append("isBillable", isBillable ? 1 : 0);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/categories.js